import React from 'react';
import { SpanDisclaimerStyled } from './styles';

export const VariableProductsFootnotesComponent = () => {
  return (
    // NOTE: Elements wrapped in parent fragments will not be rendered by our snapshot tests, so we're using a span.
    <span>
      <SpanDisclaimerStyled bold>
        Before investing in a variable product, you should carefully consider the objectives, risks and charges
        associated with its investment options. For this and other information about a Contract, you should obtain the
        appropriate Contract and underlying fund prospectuses by contacting your Northwestern Mutual Financial
        Representative. Read the prospectuses carefully before you invest.&nbsp;
      </SpanDisclaimerStyled>
      Mason Street Advisors, LLC (MSA) is the principal investment adviser for all the Portfolios in the Northwestern Mutual Series Fund (Series Fund). (Portfolios in the Series Fund are identified by the parenthetical next to the portfolio name.) MSA has engaged and oversees sub&#45;advisers who provide day&#45;to&#45;day management for certain of the Series Fund Portfolios. Each sub&#45;adviser may be replaced without the approval of shareholders. Please see the prospectus for more information. Additional fund options are advised by Russell Investments, Fidelity Investments, Neuberger Berman Investment Advisers LLC and UBS Asset Management (Americas) LLC.&nbsp;
      All securities are offered through&nbsp;
      <SpanDisclaimerStyled bold>
        Northwestern Mutual Investment Services&nbsp;
      </SpanDisclaimerStyled>
      LLC, (NMIS), 720 E. Wisconsin Avenue, Milwaukee, WI 53202, 1&#45;866&#45;664&#45;7737. Member FINRA and SIPC. NMIS is a subsidiary of Northwestern Mutual.
    </span>
  );
};

export default VariableProductsFootnotesComponent;
